<div class="login-box">
  <div class="login-logo">
    <a href="#"><b>Seller</b> Node</a>
  </div>
  <!-- /.login-logo -->
  <div class="login-box-body">
    <p class="login-box-msg">Sign in to start your session</p>

    <form [formGroup]="loginForm" (ngSubmit)="login()">

      <div class="form-group has-feedback">
        <input class="form-control" placeholder="Email" type="email" formControlName="username">
        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
      </div>
      <div class="form-group has-feedback">
        <input class="form-control" placeholder="Password" type="password" formControlName="password">
        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
      </div>
      <div class="row">
        <div class="col-xs-8">
          <div class="checkbox icheck">
            <label>
              <input type="checkbox"> Remember Me
            </label>
          </div>
        </div>
        <!-- /.col -->
        <div class="col-xs-4">
          <button type="submit" [disabled]="!loginForm.valid" class="btn btn-primary btn-block btn-flat">Sign In</button>

        </div>
        <!-- /.col -->
      </div>

    </form>
    <!-- /.social-auth-links -->
<!--
    <a [routerLink]="'/login/forgot'">I forgot my password</a><br>
    <a [routerLink]="'/login/register'" class="text-center">Register a new membership</a>
-->
  </div>
  <!-- /.login-box-body -->
</div>
<!-- /.login-box -->
